__turbopack_context__.v({
  "caption": "AgHcBa_caption",
  "image": "AgHcBa_image",
  "inner": "AgHcBa_inner",
  "root": "AgHcBa_root",
});
